import { useQuery } from '@apollo/client'
import { GET_ME } from 'api/auth/me'
import { isPartialFailure } from 'shared/utils/is-partial-failure'
import { showSignUpDialogOrError } from '../utils/show-sign-up-dialog-or-error'

export function useUser() {
  const { data, loading, error, refetch } = useQuery(GET_ME, {
    onError: e => {
      if (isPartialFailure(e)) return

      showSignUpDialogOrError(e)
    }
  })

  const userData = data?.me

  return {
    userData,
    loading,
    error,
    refetchUser: refetch
  }
}
